export default __webpack_public_path__ + "static/media/Videography2.5fc5b2f4.png";